import { dataHooks } from '@wix/data-hooks';

export const communityNavSubHeaderDataHooks = dataHooks<{
  root: {};
  title: {};
  dropdown: { id: string };
  trigger: { id: string };
  action: {};
  mobileTrigger: {};
  mobileModal: {};
  mobileContent: {};
}>('community-nav-sub-header');
